export default "__VITE_ASSET__23be93c5__"